module.exports = __webpack_public_path__ + "img/have-a-good-day.38fc5a83.png";